import { render } from "./Index.vue?vue&type=template&id=5fdd48d2&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5fdd48d2&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=1&id=5fdd48d2&scoped=true&lang=css"
import "./Index.vue?vue&type=style&index=2&id=5fdd48d2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fdd48d2"]])

export default __exports__